<template>
    <div class="container">
        <form class="form-signin" v-on:submit.prevent="loginSubmit">
            <h2 class="form-signin-heading">{{langLoginPage.login[locale]}}</h2>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <font-awesome-icon style="margin: auto" icon="envelope"/>
                    </span>
                </div>
                <input type="email" id="loginEmail" class="form-control" :placeholder="langLoginPage.emailPlaceholder[locale]" v-model="credential.email" required autofocus>
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <font-awesome-icon style="margin: auto" icon="lock"/>
                    </span>
                </div>
                <input type="password" id="loginPassword" class="form-control" :placeholder="langLoginPage.passwordPlaceholder[locale]" v-model="credential.password" required>
            </div>
            <b-alert variant="danger" :show="!!login.errMessage">{{login.errMessage}}</b-alert>
            <nettipyora-button :text="langLoginPage.login[locale]" :loading="login.loading" :className="'btn-primary'" :submit="true" />
            <br />
            <router-link to="/forgot" class="forgot-password-link">{{langLoginPage.forgotPassword[locale]}}</router-link>
        </form>
        <br />
        <br />
        <form class="form-register" v-on:submit.prevent="registrationSubmit">
            <h2 class="form-register-heading">{{langLoginPage.register[locale]}}</h2>
            <form-input :labelText="langLoginPage.name[locale]" :placeholder="langLoginPage.name[locale]" v-model="registration.name" :required="true" :tooltipTitle="langLoginPage.nameToolTip[locale]"/>
            <form-input :labelText="langLoginPage.email[locale]" :placeholder="langLoginPage.email[locale]" v-model="registration.email" :inputType="'email'" :required="true" :tooltipTitle="langLoginPage.emailToolTip[locale]"/>
            <form-select :labelText="langLoginPage.selectARole[locale]" v-model="registration.role" :options="[{text: langLoginPage.selectARole[locale], value: ''}, {text: langLoginPage.individual[locale], value: 'individual'}, {text: langLoginPage.store[locale], value: 'store'}]" :allowedValues="['individual', 'store']" :required="true" :tooltipTitle="langLoginPage.selectARoleToolTip[locale]"/>
            <form-input :labelText="langLoginPage.phone[locale]" :placeholder="langLoginPage.phone[locale]" v-model="registration.phone" :required="true" :tooltipTitle="langLoginPage.phoneToolTip[locale]"/>
            
            <form-select :labelText="langLoginPage.selectACity[locale]" v-model="registration.city" @change="cityChanged" :options="[{text: langLoginPage.selectACity[locale], value: null}].concat(CITIES.map(item =>{return item.Kunta;}).filter(item => !!item).sort((a, b) => {return a.toString().localeCompare(b);}))" :allowedValues="CITIES.map(item =>{return item.Kunta;}).filter(item => !!item).sort((a, b) => {return a.toString().localeCompare(b);})" :required="true" :tooltipTitle="langLoginPage.selectACityToolTip[locale]"/>
            <form-select :labelText="langLoginPage.selectAProvince[locale]" v-model="registration.province" :options="[{text: langLoginPage.selectAProvince[locale], value: null}].concat(PROVINCES.map(item => {return item;}).sort((a, b) => {return a.toString().localeCompare(b);}))" :allowedValues="PROVINCES.map(item => {return item;})" :required="true" :tooltipTitle="langLoginPage.selectAProvinceToolTip[locale]" disabled/>
            
            <form-input v-if="registration.role === 'store'" :labelText="langLoginPage.address[locale]" :placeholder="langLoginPage.address[locale]" v-model="registration.address" :required="true" :tooltipTitle="langLoginPage.addressToolTip[locale]"/>
            <form-input :labelText="langLoginPage.website[locale]" :placeholder="langLoginPage.website[locale]" v-model="registration.website" :inputType="'url'" :tooltipTitle="langLoginPage.websiteToolTip[locale]"/>
            <form-input :labelText="langLoginPage.password[locale]" :placeholder="langLoginPage.password[locale]" v-model="registration.password" :inputType="'password'" :required="true" :tooltipTitle="langLoginPage.passwordToolTip[locale]"/>
            <form-input :labelText="langLoginPage.confirmPassword[locale]" :placeholder="langLoginPage.confirmPassword[locale]" v-model="registration.confirmPassword" :inputType="'password'" :required="true" :tooltipTitle="langLoginPage.confirmPasswordToolTip[locale]" :extraValidation="registration.password === registration.confirmPassword"/>

            <nettipyora-button v-if="registration.role === 'store'" :text="langLoginPage.addMoreContacts[locale]" :className="'btn-outline-secondary'" :clickHandler="addMoreContacts" />
            <br />
            <br />
            <div class="more-contacts" v-for="(contact, n) in registration.contacts" :key="n">
                <form-input :labelText="langLoginPage.name[locale]" :placeholder="langLoginPage.name[locale]" v-model="contact.name" :required="true" :tooltipTitle="langLoginPage.nameToolTip[locale]"/>
                <form-input :labelText="langLoginPage.email[locale]" :placeholder="langLoginPage.email[locale]" v-model="contact.email" :inputType="'email'" :required="true" :tooltipTitle="langLoginPage.emailToolTip[locale]"/>
                <form-input :labelText="langLoginPage.phone[locale]" :placeholder="langLoginPage.phone[locale]" v-model="contact.phone" :required="true" :tooltipTitle="langLoginPage.phoneToolTip[locale]"/>
                <form-check-boxes :labelText="langLoginPage.selectLanguages[locale]" v-model="contact.languages" :options="[{text:'EN', value:'EN'}, {text:'FI', value:'FI'}, {text:'SV', value:'SV'}]"/>
                <font-awesome-icon style="cursor: pointer; color: red; font-size: 25px; position: absolute; top: 0px; right: -20px;" icon="times-circle" v-on:click.stop="registration.contacts.splice(n, 1)"/>
            </div>
            <!--
            <label class="label text-left"><strong>{{langLoginPage.userImage[locale]}}</strong></label>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <font-awesome-icon style="margin: auto" icon="file-image"/>
                    </span>
                </div>
                <div class="form-control" style="height: 100px">
                    <img :src="image ? image.uri : require('../assets/upload.png')" width="85" height="85" onclick="document.getElementById('user-image-input').click(); return false;"/>
                    <input type="file" id="user-image-input" ref="userImage" v-on:change.stop="userImageChange"/>
                </div>
                <div class="input-group-append">
                    <span class="input-group-text" v-bind:class="image ? 'text-success' : ''" v-b-tooltip.hover :title="langLoginPage.userImageToolTip[locale]">
                        <font-awesome-icon style="margin: auto" :icon="image ? 'check' : 'exclamation'"/>
                    </span>
                </div>
            </div>
            -->
            <br v-if="registration.contacts.length > 0 && registration.role === 'store'" />
            <br v-if="registration.contacts.length > 0 && registration.role === 'store'" />
            <b-alert :variant="register.statusOk ? 'success':'danger'" :show="!!register.okMessage || !!register.errMessage" >{{register.okMessage || register.errMessage}}</b-alert>
            <nettipyora-button :text="langLoginPage.submit[locale]" :loading="register.loading" :className="'btn-primary'" :submit="true" />
            <br />
            <br />
        </form>
    </div>
</template>

<script>
/* eslint-disable no-console */
// @ is an alias to /src
import NettipyoraButton from '@/components/NettipyoraButton';
import FormInput from '@/components/FormInput';
import FormSelect from '@/components/FormSelect';
import FormCheckBoxes from '@/components/FormCheckBoxes';
import { mapState } from 'vuex';
import { EMAIL_REGEX, URL_REGEX, CITIES, PROVINCES } from '@/store/constant';
import fileUploaderMixin from '@/mixins/fileUploaderMixin';
import langLoginPage from '@/store/lang/loginPage';

export default {
    name: 'login',
    mixins: [fileUploaderMixin],
    components: {
        NettipyoraButton, FormInput, FormSelect, FormCheckBoxes
    },
    computed: mapState({
        locale: state => state.locale,
        login: state => state.Login.login,
        register: state => state.Login.register
    }),
    data() {
        return {
            langLoginPage, CITIES, PROVINCES,
            emailRegex: EMAIL_REGEX,
            urlRegex: URL_REGEX,
            buttonText: "Login",
            buttonType: "normal",
            image: null,
            imageContentType: "",
            credential:  {email: this.$route.query.email ? this.$route.query.email:"", password: ""},
            registration: {
                name: "",
                email: "",
                phone: "",
                password: "",
                confirmPassword: "",
                role: "",
                province: null,
                city: null,
                address: "",
                contacts: [],
                website: "",
                imageURI: ""
            }
        }
    },
    methods: {/*
        userImageChange() {
            const self = this;
            const files = self.$refs.userImage.files;
            self.contentType = files[0].type;
            self.image = {
                uri: URL.createObjectURL(files[0]), 
                file: files[0]
            };
        },
        uploadImage() {
            const self = this;
            if(self.image) self.singeFileUploader(self.image).then(url => {
                self.registration.imageURI = url;
                self.registrationSubmit();
            }).catch(err => {
                throw err;
            });
        },*/
        cityChanged(val) {
            for(let i=0; i<this.CITIES.length; i++) {
                if(this.CITIES[i].Kunta === val) {
                    this.registration.province = this.CITIES[i].Maakunta;
                    return;
                }
            }
        },
        loginSubmit() {
            this.$store.dispatch('LOGIN', this.credential);
        },
        registrationSubmit() {
            if(this.registration.password.length < 8) return this.$store.commit('LOGIN_REGISTER_ERROR', this.locale === 'en' ? 'Password length must be more than 7 characters.':'Salasanan pituus täytyy olla yli 7 merkkiä.');
            if(this.registration.password !== this.registration.confirmPassword) return this.$store.commit('LOGIN_REGISTER_ERROR', this.locale === 'en' ? "Password and Confirm Password fields don't match.":"Salasana ja salasanan vahvistus eivät ole samat.");

            this.$store.dispatch('LOGIN_REGISTER', this.registration).then(() => {
                this.registration = {
                    name: "",
                    email: "",
                    phone: "",
                    password: "",
                    confirmPassword: "",
                    role: "",
                    province: null,
                    city: null,
                    address: "",
                    contacts: [],
                    website: "",
                    imageURI: ""
                };
                this.image = null
            });
        },
        addMoreContacts() {
            const self = this;
            self.registration.contacts.push({
                name: "",
                email: "",
                phone: "",
                languages: []
            });
        },
        showModalError() {
        }
    }
}
</script>

<style scoped>
.label {
    font-size: 0.8em;
    display: block;
    margin: 0;
    margin-left: 10px;
}

#user-image-input {
    width:0;
    height: 0;
    visibility: hidden;
}
.form-control img {
    cursor: pointer;
}
.form-signin-heading, .form-register-heading{
    color: #636363;
}
.form-signin {
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
.forgot-password-link {
    padding: 5px; 
    font-size: .8em; font-weight: bold;
}
.forgot-password-link:hover {
    text-decoration: underline;
}
.form-register {
    max-width: 800px;
    margin: auto;
}
.more-contacts {
    max-width: 500px;
    padding: 15px;
    margin: 0 auto;
    position: relative;
}
.form-signin .input-group-text, .form-register .input-group-text {
    width: 45px;
}
.form-signin .form-signin-heading,
.form-signin .checkbox {
    margin-bottom: 10px;
}
.form-signin .checkbox {
    font-weight: normal;
}
.form-signin .form-control {
    position: relative;
    height: auto;
    -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
            box-sizing: border-box;
    padding: 10px;
    font-size: 16px;
}
.form-signin .form-control:focus {
    z-index: 2;
}
select:not([multiple]) {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-position: right 50%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=);
    padding-right: 1.5em
}
.checkbox-inline {
    margin-left: 10px;
    margin-right: 10px;
}
.checkbox-inline input {
    margin: 5px;
}
</style>
